import { HttpClient } from "@angular/common/http";
import AlternalUnitMeasurementAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/materials/material/alternal-unit-measure/alternal-unit-measure.entity";
import { query } from "@angular/animations";
import { IResult } from "app/common/interfaces";
import { ICreateUnitMeasure } from "app/modules/components/material/material/interfaces/create-unit-measure.interface";
import { IUpdateMaterial } from "app/modules/components/material/material/interfaces/update-material.interface";
import { AbstractService } from "app/services/abstract.service";
import { environment as env } from "../../../../../../environments/environment.prod";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ICreateInterlocutor } from "./interfaces/create-distribution-chain-interlocutor.interface";
import { IUpdateInterlocutor } from "./interfaces/update-distribution-chain-interlocutor.interface";
import BusinessPartnerInterlocutorAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/businness-partner-interloculor/businness-partner-interloculor.entity";
const apiUrl = env.API_BUSINESS_PARTNER;
const moduleName = "business-partner-interlocutors";

@Injectable({
  providedIn: "root",
})
export class BusinessPartnerInterlocutorService extends AbstractService<
BusinessPartnerInterlocutorAttributes,
ICreateInterlocutor,
IUpdateInterlocutor
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findByBusinessId(businessId: string,distributionChainId:string): Observable<IResult<BusinessPartnerInterlocutorAttributes>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/${businessId}/${distributionChainId}`;
    return this.http.get<IResult<BusinessPartnerInterlocutorAttributes>>(API_URL);
  }
}